import React, { useEffect, useState } from 'react';
import { getProfileInitial } from '../../utils/profileInitial';

const VARIANT_CLASS = {
  header: 'user-avatar',
  menu: 'mobile-user-menu-avatar',
  dropdown: 'profile-avatar-large',
};

/**
 * Profile avatar with photo or initial placeholder (blue circle + first letter).
 */
const ProfileAvatar = ({
  variant = 'header',
  imageUrl,
  profile,
  className = '',
  title,
  imgAlt = 'Profile',
}) => {
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [imageUrl]);

  const showPhoto = Boolean(imageUrl) && !imageFailed;
  const baseClass = VARIANT_CLASS[variant] || 'user-avatar';

  const classes = [
    baseClass,
    className,
    variant === 'header' && (showPhoto ? 'user-avatar--photo' : 'user-avatar--placeholder'),
    variant === 'menu' && !showPhoto && 'mobile-user-menu-avatar--placeholder',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} title={title} aria-hidden={imgAlt === '' ? true : undefined}>
      {showPhoto ? (
        <img src={imageUrl} alt={imgAlt} onError={() => setImageFailed(true)} />
      ) : (
        <span className="profile-avatar-initial" aria-hidden="true">
          {getProfileInitial(profile)}
        </span>
      )}
    </div>
  );
};

export default ProfileAvatar;
